import { render, staticRenderFns } from "./vehicle-player-stage.vue?vue&type=template&id=22bdafba&"
import script from "./vehicle-player-stage.vue?vue&type=script&lang=js&"
export * from "./vehicle-player-stage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports